import React from "react";
import Localize from "../Localize/Localize";
import LocalizeKeys from "../Localize/LocalizeKeys";
import "./DataPage.css";

/**
 * Scroll container shared by the table screens (Invoices, Transactions): centers the content and
 * leaves room for the fixed NavBar. Pass hasNavBar={false} on routes rendered without one.
 */
const DataPage = ({ children, hasNavBar = true }) => (
    <div className={`data-page${hasNavBar ? "" : " data-page-no-navbar"}`}>
      <div className="data-page-content">{children}</div>
    </div>
);

/**
 * Detail popup shown on top of the table, which stays mounted underneath. Closes on the back
 * button, a click on the backdrop, or Escape.
 */
class DataPageModal extends React.Component {

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape") this.props.onClose();
  };

  render() {
    const { title, onClose, children } = this.props;

    return (
        <div className="data-page-overlay" onClick={onClose}>
          <div className="data-page-modal" onClick={(e) => e.stopPropagation()}>
            {title && <h2 className="data-page-modal-title">{title}</h2>}
            <div className="data-page-modal-details">{children}</div>
            <button className="data-page-modal-back" onClick={onClose}>
              {Localize.translate(LocalizeKeys.BUTTON_BACK)}
            </button>
          </div>
        </div>
    );
  }
}

export { DataPage, DataPageModal };
